const menuList = [
  {
    text: "layout.dashboard",
    icon: "chart-line",
    route: "/dashboard"
  },
  // {
  //   text: "layout.customer",
  //   icon: "account",
  //   route: "/customer"
  // },
  {
    text: "layout.landlord",
    icon: "account",
    route: "/landlord"
  },
  {
    text: "layout.plans",
    icon: "account",
    route: "/landlord_plans"
  },
  {
    text: "layout.subscriptions",
    icon: "account",
    route: "/landlord_subscriptions"
  },
  {
    text: "layout.billings",
    icon: "account",
    route: "/landlord_billings"
  },
  // {
  //   text: "landlord.requestLandlord",
  //   icon: "account-alert",
  //   route: "/requested_landlord"
  // },
   {
    text: "contactRequests.contactRequests",
    icon: "account-alert",
    route: "/contact_requests"
  },
  // {
  //   text: "layout.properties",
  //   icon: "domain",
  //   route: "/properties"
  // },
  {
    text: "layout.property",
    icon: "city",
    route: "/property"
  },
  // {
  //   text: "layout.bookings",
  //   icon: "bookmark",
  //   route: "/bookings"
  // },
  // {
  //   text: "layout.payments",
  //   icon: "credit-card",
  //   route: "/payments"
  // },
  {
    text: "layout.settings",
    icon: "cog",
    route: "/settings"
  },
  // {
  //   text: "contract.contract",
  //   icon: "file-document-edit",
  //   route: "/contract"
  // },
  // {
  //   text: "common.promotions",
  //   icon: "bullhorn-variant",
  //   route: "/promoted_landlords"
  // },
  {
    text: "layout.privacyPolicy",
    icon: "file-document-edit",
    route: "/privacy_policy"
  },
  {
    text: "termsAndCondition.termsAndCondition",
    icon: "file-document-edit",
    route: "/terms_and_condition"
  }
];
export default menuList;
